import React, { useState, useEffect } from "react";
import stylesheet from "./home.module.css";
import Banner from "../../webincludes/banner/banner";
import Header from "../../webincludes/header/index";
import Footer from "../../webincludes/footer/index";
import Reveal from "react-awesome-reveal";
import { keyframes } from "@emotion/react";
import Cbd from "../../../assets/images/CBD.webp";
import ProductCard from "../../webincludes/productcard/index";
import Product_image1 from "../../../assets/images/weed_product.webp";
import Product_image2 from "../../../assets/images/CBD2.webp";
import Product_image3 from "../../../assets/images/CBD3.webp";
import Product_image4 from "../../../assets/images/CBD4.webp";
import { getTheme } from "../../../actions/localtheme";
import { connect } from "react-redux";

const Home = (props) => {
  const customAnimation = keyframes`
  from {
    opacity: 0;
    transform: translate3d(-200px, -100px, 0);
  }

  to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
`;
  const FadeUP = keyframes`
  from {
    opacity: 0;
    transform: translateY(200px);
  }

  to {
    opacity: 1;
    transform: translateY(0px);
  }
`;
  const FadeLEFT = keyframes`
  from {
    opacity: 0;
    transform: translateX(500px);
  }

  to {
    opacity: 1;
    transform: translateY(0px);
  }
`;

  const [gamechange, setgamechange] = useState("");
  useEffect(() => {
    props.getTheme();
    setgamechange(props.ThemeReducer.theme);
  }, [gamechange]);

  const [Product, setProduct] = useState([
    {
      title: "Flower",
      description:
        "3.5 grams of exceptional CREATE Flowers rich in CBD. 100% Swiss-Made. Tobacco and nicotine free.",
      price: "300",
      image: Product_image1,
    },
    {
      title: "Pre-Rolled",
      description:
        "3.5 grams of exceptional CREATE Flowers rich in CBD. 100% Swiss-Made. Tobacco and nicotine free.",
      price: "300",
      image: Product_image2,
    },
    {
      title: "CBD OIL",
      description:
        "3.5 grams of exceptional CREATE Flowers rich in CBD. 100% Swiss-Made. Tobacco and nicotine free.",
      price: "300",
      image: Product_image3,
    },
    {
      title: "Refil",
      description:
        "3.5 grams of exceptional CREATE Flowers rich in CBD. 100% Swiss-Made. Tobacco and nicotine free.",
      price: "300",
      image: Product_image4,
    },
  ]);

  function detailpage() {
    console.log("detail page");
  }

  function addtocart() {
    console.log("add to cart");
  }

  return (
    <>
      <div>
        <Header />
      </div>
      <div>
        <Banner />
      </div>
      <div className={stylesheet.main_body}>
        <div className={stylesheet.waveone}></div>
        <div className="container">
          <div className={stylesheet.home_text_box}>
            <div className={stylesheet.sec_spec}>
              <Reveal keyframes={customAnimation}>
                <h3>We are the</h3>
                <h1 style={{ color: props.ThemeReducer.theme }}>
                  Christian Virtual Marketplace
                </h1>
                <h5 className="mt-3">
                  A journey into CBD Cannabis, our Worlds created to accompany
                  you in the discovery of a plant with properties handed down
                  over millennia. CBD Cannabis is a rare, natural product that
                  can improve your innate abilities and helps you break down
                  your boundaries. Don’t be trapped by rules, revive your energy
                  and start a journey to freedom and growth enjoying all the
                  natural properties of the True CBD Cannabis.
                </h5>
              </Reveal>
            </div>

            <div className={stylesheet.sec_spec}>
              <Reveal keyframes={customAnimation}>
                <h3>cultivating</h3>
                <div className="row">
                  <div className="col-lg-12">
                    <div className={stylesheet.png_rotate}></div>
                    <h1 style={{ color: props.ThemeReducer.theme }}>
                      excellence
                    </h1>
                    <h5>
                      MA True Cannabis was established in 2018 with the aim of
                      profoundly redesigning the CBD cannabis market at an
                      international level. We are based in Switzerland,where we
                      proudly produce outstanding varieties of CBD Cannabis
                      Flowers, in full compliance with the limits of the law.
                    </h5>
                  </div>
                </div>
              </Reveal>
            </div>

            <div className={stylesheet.sec_spec}>
              <Reveal keyframes={customAnimation}>
                <h3>We are the</h3>
                <h1 style={{ color: props.ThemeReducer.theme }}>
                  True CBD Cannabis
                </h1>
                <div className="row">
                  <div className="col-lg-12">
                    <h4 style={{ color: props.ThemeReducer.theme }}>
                      Our vision
                    </h4>
                  </div>
                  <div className="col-lg-6">
                    <h5>
                      MA True Cannabis was established in 2018 with the aim of
                      profoundly redesigning the CBD cannabis market at an
                      international level. We are based in Switzerland,where we
                      proudly produce outstanding varieties of CBD Cannabis
                      Flowers, in full compliance with the limits of the law.
                    </h5>
                  </div>
                  <div className="col-lg-6">
                    <Reveal keyframes={FadeUP}>
                      <h5>
                        MA True Cannabis was established in 2018 with the aim of
                        profoundly redesigning the CBD cannabis market at an
                        international level. We are based in Switzerland, where
                        we proudly produce outstanding varieties of CBD Cannabis
                        Flowers, in full compliance with the limits of the law.
                      </h5>
                    </Reveal>
                  </div>
                </div>
              </Reveal>
            </div>

            <div className={stylesheet.sec_spec}>
              <Reveal keyframes={customAnimation}>
                <div className="row">
                  {Product !== undefined &&
                  Product !== null &&
                  Product !== "" &&
                  Product.length > 0
                    ? Product.map((data) => (
                        <div className="col-lg-6 p-4">
                          <ProductCard
                            func={detailpage}
                            Addcart={addtocart}
                            image={data.image}
                            title={data.title}
                            description={data.description}
                            price={data.price}
                          />
                        </div>
                      ))
                    : ""}
                </div>
              </Reveal>
            </div>
          </div>
        </div>
      </div>
      <div>
        <Footer />
      </div>
    </>
  );
};

const mapStateToProps = (state) => ({
  ThemeReducer: state.ThemeReducer,
});

const mapDispatchToProps = (dispatch) => ({
  getTheme: (theme) => dispatch(getTheme(theme)),
});
export default connect(mapStateToProps, mapDispatchToProps)(React.memo(Home));
